"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const global_1 = require("aws-sdk/global");
const awsSecurityConfiguration_1 = require("../__init/awsSecurityConfiguration");
const ConnectionClass = require('@lyearn-team/http-aws-es');
const Elasticsearch = require('@lyearn-team/elasticsearch');
function getUserAWSClient(elasticsearchUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { getAccessKey, getSecretKey, getSessionToken } = awsSecurityConfiguration_1.awsSecurityConfiguration.getCredentialGetters();
        const awsAccessKey = (yield getAccessKey()) || process.env.ES_AWS_ACCESS_KEY_ID;
        const awsSecretKey = (yield getSecretKey()) || process.env.ES_AWS_SECRET_ACCESS_KEY;
        const sessionToken = yield getSessionToken();
        const elasticsearchClient = new Elasticsearch.Client({
            host: elasticsearchUrl || process.env.AWS_ES_URL,
            requestTimeout: 90000,
            log: 'error',
            connectionClass: ConnectionClass,
            awsConfig: new global_1.Config({
                region: 'us-east-1',
                credentials: new global_1.Credentials(awsAccessKey, awsSecretKey, sessionToken)
            })
        });
        return elasticsearchClient;
    });
}
exports.getUserAWSClient = getUserAWSClient;
//# sourceMappingURL=getUserAWSClient.js.map